import timm from 'timm';

import {
  Types,
}            from 'app/actions/company-admin/companies';
import utils from 'app/reducers/utils';

const initialState = {
  idAttnNumsMap: {},
  updateSsoPending: false,
};

const reducer = utils.createReducer(initialState, {

  [`${Types.GET_ATTN_NUMS}_RESOLVED`]: (state, {result}) => {
    return timm.mergeIn(state, ['idAttnNumsMap', result.companyId], result);
  },

  [`${Types.UPDATE_SSO}_PENDING`]: (state, action) => {
    return {...state, updateSsoPending: true};
  },
  [`${Types.UPDATE_SSO}_RESOLVED`]: (state, action) => {
    return {...state, updateSsoPending: false};
  },
  [`${Types.UPDATE_SSO}_REJECTED`]: (state, action) => {
    return {...state, updateSsoPending: false};
  },

});

export default reducer;
